<!-- 首页-行业应用模块 -->
<template>
  <div class="industryVideo">
    <homeModuleHead :apply="apply"></homeModuleHead>
    <div class="industryVideo-center">
  
      <div class="all" id="video-box">
        <div class="screen">
          <ul>
            <li v-for="(item, index) in videoList" :key="index">
              <div class="film" v-if="nowIndex !== index"></div>
              <div class="film film-transparent" v-if="nowIndex === index && !playState" @click="playVideo">
                <div class="video-title">
                  <span>{{item.videoName}}</span>
                  <span>观看影片
                    <i class="icon-video-play"></i>
                  </span>
                </div>
              </div>
              <!-- <div class="video-title" v-if="nowIndex === index && !playState" @click="playVideo">
                <span>{{item.videoName}}</span>
                <span>观看影片
                  <i class="icon-video-play"></i>
                </span>
              </div> -->
              <video
                :ref="'videoPlayer'+index"
                :poster="item.imgUrl"
                class="video-apply"
                :id="'myVideo'+index"
                :src="item.videoUrl"
                :controls="nowIndex === index ? playState : false"
                :autoplay="false"
                @play="play"
                @pause="pause"
                @ended="ended"
                controlslist="nodownload  noremoteplayback disablePictureInPicture"
                disablePictureInPicture
              >
              </video>
            </li>
          </ul>
          <ol>
          </ol>
        </div>
        <div id="arr">
          <span id="left"><i class="el-icon-arrow-left"></i></span>
          <span id="right"><i class="el-icon-arrow-right"></i></span>
        </div>
      </div>
  
      <vue-seamless-scroll :data="videoList" class="seamless-warp" :class-option="classOption">
        <ul>
           <li v-for="(item,index) in videoList" :key="index" @click="toIndustryApplication">
              <div class="film-img">
                <span>观看更多影片<i class="icon-video-play"></i></span>
              </div>
              <img :src="item.imgUrl" alt="">
            </li>
        </ul>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll' // 引入热播功能组件
import homeModuleHead from './HomeModuleHead.vue' // 头部
export default {
  name: 'industryVideo',
  components: {vueSeamlessScroll, homeModuleHead},
  props: {
    title: {//模块标题
        type: String,
        default: ""
    },
    projectList: {
      Type: Array,
      default() {
        return [];
      }
    },
  },
  data() {
    return {
      apply: {
        titleEnglish: ['INDUSTRY', 'APPLICATION'],
        title: '行业应用',
        intro: "丰富的行业应用案例，让AI学习更开阔",
        more: "进入应用",
        redirect: "/industral/application/index",
        openUrl: "application"
      },
      videoList: [], //
      autoplay: true, //是否自动切换
      isPlay: false, //播放状态
      isIn: false, //鼠标是否位于播放器内
      cutTime: 5000, //轮播时间，单位毫秒
      nowIndex: 1, // 行业应用走马灯当前下标
      playState: false, // 播放状态
      timer: null,
    }
  },
  watch:{
    projectList(val) {
      if (val) {
        this.videoList = JSON.parse(JSON.stringify(val))
        if (this.videoList.length > 1) {
          this.videoList.push(this.videoList[0])
          this.videoList.push(this.videoList[1])
        }
      }
    }
  },
  computed: {
    classOption () {
       return {
        step: 1, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  created() {},
  mounted() {
    //初始监听第一个视频
    // this.listenVideo();
    this.videoRotation()
  },
  methods: {
    // 视频轮播
    videoRotation() {
      let this_ = this
      // 实现：
      // 1 获取元素
      var box = document.getElementById('video-box'); // 大盒子
      var screenBox = box.children[0]; // 可视区域
      var imgWidth = screenBox.offsetWidth; // 获取可视区域宽度作为图片宽度使用
      var ul = screenBox.children[0]; // 运动的ul
      var ulLis = ul.children; // ul中的所有子元素li
      var ol = screenBox.children[1]; // 小方块的父元素
      var olLis = ol.children; // ol中的所有子元素li
      var arrBox = box.children[1]; // 左右箭头父盒子
      var arrLeft = arrBox.children[0]; // 左箭头
      var arrRight = arrBox.children[1]; // 右箭头
  
      // 2 根据ul中的图片张数创建底部小方块
      // for (var i = 0; i < ulLis.length; i++) {
      //   var li = document.createElement('li');
      //   li.innerText = i + 1;
      //   ol.appendChild(li);
      // }
      // // 3 给创建的第一个小方块设置默认类名current
      // olLis[0].classList.add('current');
  
      // 4 给小方块设置点击事件
      // for (i = 0; i < olLis.length; i++) {
      //   // 给ol中每个li设置自定义属性data-index,用于保存索引
      //   // olLis[i].setAttribute('data-index', i);
      //   olLis[i].dataset.index = i;
  
      //   olLis[i].onclick = function () {
      //     // --- 设置假的第一张后添加的功能
      //     if (count === ulLis.length - 1) {
      //       ul.style.left = 0;
      //       // count = 0; // 因为后面设置过对count的赋值，此处不需要写了
      //     }
  
      //     // 4.1 设置点击按钮变色的功能
      //     for (var i = 0; i < olLis.length; i++) {
      //       olLis[i].classList.remove('current');
      //     }
      //     this.classList.add('current');
  
      //     // 4.2 设置ul根据点击的按钮进行运动
      //     //   - 需要通过自定义属性保存索引
      //     var target = -this.dataset.index * imgWidth; // 保存目标位置
      //     //   - 通过move，让ul运动到target的位置即可
      //     move(ul, target);
  
      //     // --- 将当前元素的索引设置给count，让效果联动
      //     count = this.dataset.index;
      //   };
      // }
  
      // ----- 左右按钮操作功能 ----- 
      // 1 设置大盒子box移入移出时，箭头arrBox的显示隐藏
      // box.addEventListener('mouseover', function () {
      //   arrBox.style.display = 'block';
      // });
      // box.addEventListener('mouseout', function () {
      //   arrBox.style.display = 'none';
      // });
  
      // 2 设置一个变量用于记录滚出去的张数
      var count = 1;
      // 设定在第二张为中间位置
      ul.style.left = imgWidth;
      var target = -count * imgWidth;
      move(ul, target);
  
      //  --- 克隆ul中的第一张图，放入到ul最后，设置为假的第一张
      // ul.appendChild(ulLis[0].cloneNode(true));
  
      // 3 设置右按钮点击事件
      arrRight.onclick = function () {
        // --- 如果当前是假的第一张显示时，应当先将ul的left抽回到0，再滚动
        if (count === ulLis.length - 2) {
          ul.style.left = 0;
          // 注意：ul的位置如果发生改变，count值要随之改变
          count = 0;
        }
  
        // - 设置计数+1
        count++;
        // - 根据count设置ul的运动位置
        var target = -count * imgWidth;
        move(ul, target);
  
        // - 设置按钮变色
        // for (var i = 0; i < olLis.length; i++) {
        //   olLis[i].classList.remove('current');
        // }
        // // 设置了假的第一张后，假的第一张显示时应当为按钮1高亮
        // if (count === ulLis.length - 1) {
        //   olLis[0].classList.add('current');
        // } else {
        //   olLis[count].classList.add('current');
        // }

        if (this_.playState) {
          let myVideo = this_.$refs['videoPlayer' + this_.nowIndex];
          myVideo[0].pause();
          this_.playState = false
        }

        this_.nowIndex = count
        // console.log(this_.nowIndex)
      };
  
      // 4 设置左按钮点击事件
      arrLeft.onclick = function () {
        // 检测当前是否显示第一张
        if (count === 1) {
          ul.style.left = -(ulLis.length - 1) * imgWidth + 'px';
          count = ulLis.length - 1; // 将count更新
        }
  
        // 基本滚动操作
        count--;
        var target = -count * imgWidth;
        move(ul, target);
        // for (var i = 0; i < olLis.length; i++) {
        //   olLis[i].classList.remove('current');
        // }
        // olLis[count].classList.add('current');

        if (this_.playState) {
          let myVideo = this_.$refs['videoPlayer' + this_.nowIndex];
          myVideo[0].pause();
          this_.playState = false
        }

        this_.nowIndex = count
        // console.log(this_.nowIndex)
      };
  
  
      // --- 自动播放功能
      // 1 设置定时器，进行自动播放
      this_.timer = setInterval(function () {
        // 2 调用右按钮的点击事件, 通过click()操作
        arrRight.click();
      }, 3000);
  
      // 3 鼠标移入时，设置自动播放停止
      //   - 需要给box重复设置onmouseover和onmouseout
      box.addEventListener('mouseover', function () {
        clearInterval(this_.timer);
      });
  
      box.addEventListener('mouseout', function () {
        if (this_.playState) {
          // console.log('播放了')
          return
        }
        // 重新开启时，必须设置给timer，而且必须是全局变量
        this_.timer = setInterval(function () {
          arrRight.click();
        }, 3000);
      });
  
      /* move函数用于让某个元素移动到指定位置
        - element 是要运动的元素，DOM对象，别写id名或标签名之类的东西
        - target 是目标位置，数值类型
      */
      function move(element, target) {
        // 为了避免元素出现抖动
        clearInterval(element.timer);
        // 设置新运动的定时器操作:
        element.timer = setInterval(function () {
          // 1 获取元素当前的位置
          var current = element.offsetLeft;
          // 2 计算每次要运动的距离(步长)
          var step = (target - current) / 10;
          // 对step计算的结果进行取整，确保至少移动1px
          //   - 根据step的正负设置对应的向上或向下取整操作
          step = step > 0 ? Math.ceil(step) : Math.floor(step);
          // 3 计算新的运动位置
          current += step;
          // 4 设置给元素的left进行运动
          element.style.left = current + 'px';
          // 5 当元素运动到目标位置后，清除定时器
          if (current === target) {
            clearInterval(element.timer);
          }
        }, 20);
      }
    },

    // 播放
    play() {
      this.playState = true
    },
    // 暂停
    pause() {
      // this.playState = false
    },
    // 播放结束
    ended() {
      this.playState = false
    },

    //播放视频
    playVideo() {
      //注意：这样获取的dom是一个数组，必须加上[0]索引才能正确的添加事件
      let myVideo = this.$refs['videoPlayer' + this.nowIndex];
      myVideo[0].play();
    },
    //暂停视频
    pauseVideo() {
      //注意：这样获取的dom是一个数组，必须加上[0]索引才能正确的添加事件
      let myVideo = this.$refs['videoPlayer' + this.nowIndex];
      myVideo[0].pause();
    },

    //获取走马灯的索引
    getIndex(nowIndex, oldIndex) {
      //用户可能在上个视频未播放完毕就切换
      //此时需要暂停上个视频并把时间归零，否则影响对当前视频的监听逻辑
      let myVideo = this.$refs['videoPlayer' + oldIndex];
      myVideo[0].pause();
      myVideo[0].currentTime = 0;
      this.nowIndex = nowIndex;
      this.listenVideo();
    },
    //监听视频的播放、暂停、播放完毕等事件
    listenVideo() {
      //注意：这样获取的dom是一个数组，必须加上[0]索引才能正确的添加事件
      let myVideo = this.$refs['videoPlayer' + this.nowIndex];
      //监听播放
      myVideo[0].addEventListener("play",()=>{
        this.autoplay = false;
        this.isPlay = true;
      });
      //监听暂停
      myVideo[0].addEventListener("pause",()=>{
        this.autoplay = true;
        this.isPlay = false;
      });
      //监听播放完毕
      myVideo[0].addEventListener("ended",()=>{
        //时间归零
        myVideo[0].currentTime = 0;
        this.autoplay = true;
        this.isPlay = false;
      });
    },
    
    toIndustryApplication() {
      this.$router.push("/industral/application/index");
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
}
</script>
<style lang="scss">
.industryVideo {
  width: 100%;
  background: #000000;

  .industryVideo-center {
    width: 1200px;
    height: 700px;
    position: relative;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 14px;
    color: #000;
    margin: 0 auto;
    padding: 0;
    overflow: hidden;
  }

  .all {
    width: 800px;
    height: 450px;
    margin: 37px auto 17px;
    position: relative;
    &:hover {
      #arr {
        display: block;
      }
    }
  }

  .screen {
    width: 800px;
    height: 450px;
    /* overflow: hidden; */
    position: relative;
    ul {
      height: 100%;
      position: absolute;
      left: 0;
      top: 0px;
      // width: 3000px;
      /* transition: left 1s; */
      display: flex;
      li {
        width: 800px;
        height: 100%;
        overflow: hidden;
        padding: 0 10px;
        box-sizing: border-box;
        position: relative;
        .video-apply {
          width: 100%;
          height: 100%;
          background-color: #ccc;
          border-radius: 18px;
          cursor: pointer;
        }
        .film {
          width: 780px;
          height: 100%;
          background-color: rgba($color: #000000, $alpha: 0.5);
          border-radius: 18px;
          position: absolute;
          z-index: 9;
        }
        .film-transparent {
          background-color: rgba($color: #000000, $alpha: 0);
          cursor: pointer;
        }
        .video-title {
          width: 780px;
          color: #fff;
          bottom: 32px;
          margin: auto;
          position: absolute;
          z-index: 9;
          display: flex;
          justify-content: space-between;
          span {
            &:first-child {
              font-size: 23px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #FFFFFF;
              line-height: 28px;
              margin-left: 30px;
            }
            &:last-child {
              width: 91px;
              height: 30px;
              color: #000;
              background-color: #fff;
              border: 1px solid #fff;
              border-radius: 25px;
              font-size: 14px;
              margin-right: 38px;
              display: flex;
              justify-content: center;
              align-items: center;
              // cursor: pointer;
              .icon-video-play {
                width: 12px;
                height: 12px;
                background: url("../../../public/images/home/icon-play.png") no-repeat;
                background-size: 100% 100%;
                margin-left: 5px;
              }
            }
          }
        }

      }
    }
  }


  .all ol {
    position: absolute;
    right: 10px;
    bottom: 10px;
    line-height: 20px;
    text-align: center;
  }
  .all ol li {
    float: left;
    width: 20px;
    height: 20px;
    background: #fff;
    border: 1px solid #ccc;
    margin-left: 10px;
    cursor: pointer;
  }
  .all ol li.current {
    background: yellow;
  }

  #arr {
    display: none;
  }
  #arr span {
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 30px;
    font-weight: 700;
    font-family: '黑体';
    color: #3E3E40;
    background: rgba(195, 184, 184, 0.66);
    border-radius: 50%;
    position: absolute;
    left: -180px;
    top: 0;
    bottom: 0;
    margin: auto;
    cursor: pointer;
    z-index: 19;
  }
  #arr #right {
    right: -180px;
    left: auto;
  }

  .seamless-warp{
    width: 100%;
    height: 160px;
    // height: calc(100% - 16px);
    overflow: hidden;
    margin: 20px auto;
    ul {
      width: 100%;
      display: flex;
      li {
        width: 300px;
        height: 160px;
        margin: 0 10px;
        border-radius: 18px;
        overflow: hidden;
        display: flex;
        position: relative;
        cursor: pointer;
        &:hover {
          .film-img {
            // display: none;
            background-color: rgba($color: #000000, $alpha: 0);
            span {
              display: block;
            }
          }
        }
        img {
          flex: 1;
        }
        .film-img {
          width: 100%;
          height: 100%;
          background-color: rgba($color: #000000, $alpha: 0.5);
          border-radius: 18px;
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            display: none;
            height: 30px;
            color: #000;
            background-color: #fff;
            border: 1px solid #fff;
            border-radius: 25px;
            font-size: 14px;
            line-height: 30px;
            padding: 0 8px;
            cursor: pointer;
            .icon-video-play {
              display: inline-block;
              width: 12px;
              height: 12px;
              background: url("../../../public/images/home/icon-play.png") no-repeat;
              background-size: contain;
              margin-left: 5px;
              vertical-align: middle;
            }
          }
        }
      }
    }
  }
}

</style>